import {ChangeDetectionStrategy, Component, HostBinding} from '@angular/core';
import {DataTablePagerComponent} from '@swimlane/ngx-datatable';

@Component({
  selector: 'app-ace-table-pager',
  templateUrl: './ace-table-pager.component.html',
  styleUrls: ['./ace-table-pager.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})

export class AceTablePagerComponent extends DataTablePagerComponent {
  @HostBinding('class') hostClass: string = 'datatable-pager';
}
